import styled from "styled-components";
import { viewMedia } from "@axum/ax-design";

export const TABLE_MEDIA = viewMedia.split;
export const SPLIT_MEDIA = viewMedia.stacked;
export const PHONE_MEDIA = viewMedia.phone;

export const LogsTable = styled.table`
  .o360-log-date,
  .o360-log-action {
    width: 1%;
    white-space: nowrap;
  }

  .o360-log-message {
    overflow-wrap: anywhere;
  }

  .o360-log-date-part {
    white-space: nowrap;
  }

  @media (max-width: 560px) {
    .o360-log-date {
      white-space: normal;
    }

    .o360-log-action-label {
      display: none;
    }
  }
`;

export const OrdersGridContainer = styled.div`
  --o360-origin-bees-bg: rgba(250, 204, 21, 0.22);
  --o360-origin-bees-border: rgba(234, 179, 8, 0.6);
  --o360-origin-bees-text: #713f12;
  --o360-origin-minegocio-bg: rgba(249, 115, 22, 0.14);
  --o360-origin-minegocio-border: rgba(249, 115, 22, 0.5);
  --o360-origin-minegocio-text: #9a3412;

  .dark-mode & {
    --o360-origin-bees-bg: rgba(250, 204, 21, 0.2);
    --o360-origin-bees-border: rgba(254, 240, 138, 0.4);
    --o360-origin-bees-text: #fde047;
    --o360-origin-minegocio-bg: rgba(249, 115, 22, 0.26);
    --o360-origin-minegocio-border: rgba(253, 186, 116, 0.4);
    --o360-origin-minegocio-text: #fdba74;
  }

  /* Sin desplazamiento propio el tema de KendoReact deja la tabla en auto, y una celda que no parte renglón ensancha su columna en vez de recortarse. */
  @media ${TABLE_MEDIA} {
    && .k-grid > table {
      table-layout: fixed;
    }

    && .o360-detail-metas {
      display: contents;
    }

    /* El total del tema crece con flex 1 desde la derecha: un hueco con la misma caja a la izquierda deja los botones al centro. */
    && .k-grid.ax-kendo > .k-pager-wrap::before,
    && .k-grid.ax-kendo > .k-pager-wrap > .k-pager-info {
      flex: 1 1 0%;
      margin: 0 var(--ax-space-4);
      padding: 0 var(--ax-space-4);
    }

    && .k-grid.ax-kendo > .k-pager-wrap::before {
      content: "";
    }
  }

  @media ${SPLIT_MEDIA} {
    && .k-grid.ax-kendo tbody > tr.k-master-row > td.o360-card-lead {
      order: 10;
    }

    && .o360-detail-metas {
      display: flex;
      flex: 1 0 100%;
      flex-wrap: wrap;
      gap: inherit;
    }
  }

  && .o360-detail-actions {
    display: flex;
    gap: var(--ax-space-2);
  }

  && .o360-items {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  && .o360-item {
    display: flex;
    flex-direction: column;
    gap: var(--ax-space-2);
    padding: var(--ax-space-3) 0;
    box-shadow: inset 0 -1px 0 var(--ax-separator);
    font-size: var(--ax-font-size-sm);
  }

  && .o360-item:first-child {
    padding-top: 0;
  }

  && .o360-item:last-child {
    box-shadow: none;
  }

  && .o360-item-head {
    display: flex;
    align-items: center;
    gap: var(--ax-space-3);
  }

  && .o360-item-name {
    flex: 1 1 auto;
    min-width: 0;
    font-weight: var(--ax-fw-medium);
  }

  && .o360-item-fields {
    display: flex;
    gap: var(--ax-space-4);
  }

  && .o360-item-field {
    flex: none;
    min-width: 4em;
    white-space: nowrap;
  }

  && .o360-item-field.is-money {
    min-width: 7.5em;
  }

  && .o360-item-label {
    display: block;
    margin-bottom: 2px;
    color: var(--ax-text-muted);
    font-size: var(--ax-font-size-xs);
  }

  && .o360-origin-bees {
    border-color: var(--o360-origin-bees-border);
    background: var(--o360-origin-bees-bg);
    color: var(--o360-origin-bees-text);
  }

  && .o360-origin-minegocio {
    border-color: var(--o360-origin-minegocio-border);
    background: var(--o360-origin-minegocio-bg);
    color: var(--o360-origin-minegocio-text);
  }

  && .o360-state-cancelled {
    border-color: rgba(var(--ax-warning-rgb), 0.45);
    background: var(--ax-warning-tint);
    color: var(--ax-warning-on-tint);
  }
`;
